module.exports = __webpack_public_path__ + "img/yuan2.c0dbca34.png";